module.exports = __webpack_public_path__ + "img/eg11.27b1b55f.png";